import { formatMoney } from "../../lib/format";

export const customPaymentMinimum = 10;

export type PaymentAmountKind = "invoice" | "account" | "custom";

export type PaymentAmountSelection = {
  amount: number;
  customAmountError: string | null;
};

export function getDefaultPaymentAmountKind(
  invoiceBalance: number | undefined,
  accountBalance: number,
): PaymentAmountKind {
  return invoiceBalance != null && invoiceBalance > 0
    ? "invoice"
    : accountBalance > 0
      ? "account"
      : "custom";
}

export function getPaymentAmountSelection(
  selected: PaymentAmountKind,
  customAmount: string,
  invoiceBalance: number | undefined,
  accountBalance: number,
): PaymentAmountSelection {
  if (selected === "invoice")
    return { amount: invoiceBalance ?? accountBalance, customAmountError: null };

  if (selected === "account") return { amount: accountBalance, customAmountError: null };

  const customAmountError = validateCustomAmount(customAmount, accountBalance);
  return {
    amount: parseMoney(customAmount) ?? 0,
    customAmountError,
  };
}

export function validateCustomAmount(value: string, accountBalance: number) {
  const amount = parseMoney(value);
  if (amount == null || amount <= 0) return "Please enter an amount.";

  if (amount > accountBalance)
    return `Cannot pay more than the account balance of ${formatMoney(accountBalance)}.`;

  if (accountBalance < customPaymentMinimum && amount < accountBalance)
    return "Balance is too low to make a partial payment. Please pay the full balance.";

  if (accountBalance >= customPaymentMinimum && amount < customPaymentMinimum)
    return `Minimum payment amount is ${formatMoney(customPaymentMinimum)}.`;

  return null;
}

function parseMoney(value: string) {
  if (!value.trim()) return null;

  const amount = Number(value);
  if (!Number.isFinite(amount)) return null;

  return Math.round(amount * 100) / 100;
}
